/**
 * Watchlist API
 */
import { apiClient } from './client'
import type { WatchlistItem, WatchlistItemCreate, WatchlistItemUpdate } from '../types'
import type { BulkOperationResult, BulkTagAction } from './holdings'

const BASE_PATH = '/api/watchlist'

export interface WatchlistListParams {
  tagIds?: string[]
}

export const watchlistApi = {
  list: async (params?: WatchlistListParams): Promise<WatchlistItem[]> => {
    const queryParams: Record<string, string> = {}
    if (params?.tagIds?.length) queryParams.tags = params.tagIds.join(',')
    const response = await apiClient.get<WatchlistItem[]>(BASE_PATH, { params: queryParams })
    return response.data
  },

  get: async (symbol: string): Promise<WatchlistItem> => {
    const response = await apiClient.get<WatchlistItem>(`${BASE_PATH}/${encodeURIComponent(symbol)}`)
    return response.data
  },

  add: async (data: WatchlistItemCreate): Promise<WatchlistItem> => {
    const response = await apiClient.post<WatchlistItem>(BASE_PATH, data)
    return response.data
  },

  update: async (symbol: string, data: WatchlistItemUpdate): Promise<WatchlistItem> => {
    const response = await apiClient.put<WatchlistItem>(`${BASE_PATH}/${encodeURIComponent(symbol)}`, data)
    return response.data
  },

  remove: async (symbol: string): Promise<void> => {
    await apiClient.delete(`${BASE_PATH}/${encodeURIComponent(symbol)}`)
  },

  bulkUpdateTags: async (
    symbols: string[],
    action: BulkTagAction,
    tagIds: string[]
  ): Promise<BulkOperationResult> => {
    const response = await apiClient.patch<BulkOperationResult>(
      `${BASE_PATH}/bulk/tags`,
      { symbols, action, tag_ids: tagIds }
    )
    return response.data
  },

  bulkDelete: async (symbols: string[]): Promise<BulkOperationResult> => {
    const response = await apiClient.delete<BulkOperationResult>(
      `${BASE_PATH}/bulk`,
      { data: { symbols } }
    )
    return response.data
  },
}
